import React, {useEffect, useState} from 'react';
import Fade from 'react-reveal/Fade';
import classes from './Card.module.css';

const CardLayout = props => {
    const [url, setUrl] = useState('');
    let playAnimation = url !== '';
    useEffect(() => {
        fetch(`/images/${props.image}.png`)
            .then(response => response.blob())
            .then((image) => setUrl(URL.createObjectURL(image)))
    }, []);

    return (
        <>
            {props.image && !props.background_exist &&
            <Fade right when={playAnimation} >
                <div className={props.image === 'call-me' ? classes.personal : classes.comment}
                     style={{backgroundImage: `url(` + url + `)`}}></div>
            </Fade>
            }
            <Fade duration={3000}>
                <div className={classes.card}>
                    {props.logo_exist &&
                    <img
                        src={`${process.env.REACT_APP_API_URL}public/img/callme/${props.logo_exist}`}
                        alt="Avatar"
                        style={{'width': '100%'}}
                    />
                    }
                    <div className={classes.container}>
                        {props.children}
                    </div>
                </div>
            </Fade>
        </>
    )
}
export default CardLayout